import { takeLatest, put, call, delay } from 'redux-saga/effects'
import {
  getAllCasinoProviders,
  getAllCasinoGames,
  createCasinoProvider,
  createCasinoGame,
  updateCasinoGame,
  updateCasinoProvider,
  superAdminViewToggleStatus,
  getSuperAdminAggregators,
  createSuperAdminAggregator,
  getSuperAdminGameCategory,
  getSuperAdminGameSubCategory,
  getAllSAProviders,
  getFreeSpinGames,
  updateReorderGames,
  deleteTenantAdminCategory,
  deleteTenantAdminSubCategory,
  deleteTenantAdminCasinoProvider,
  deleteTenantAdminCasinoGames,
  updateCasinoSubCategory,
  updateCasinoCategory,
  createCasinoSubCategory,
  createCasinoCategory,
  addGamesToSubCategory,
  updateSubCategoryReOrder,
  updateCategoryReOrder,
  getSuperAdminPopularGame,
  handlePopularGame,
  getSuperAdminNewGame,
  updateStatus,
  updateCasinoGameThumbnailURL,
  deleteCasinoCategory,
  addCasinoGameCategory,
  getCategoryGames,
  getCategoryGamesCount,
  deleteCagegoryGame
} from '../../utils/apiCalls'
import {
  getAllCasinoProvidersStart,
  getAllCasinoProvidersSuccess,
  getAllCasinoProvidersFailure,
  createCasinoProviderStart,
  createCasinoProviderComplete,
  updateCasinoProviderStart,
  updateCasinoProviderComplete,
  getAllCasinoGamesStart,
  getAllCasinoGamesSuccess,
  getAllCasinoGamesFailure,
  createCasinoGameStart,
  createCasinoGameComplete,
  updateCasinoGameStart,
  updateCasinoGameComplete,
  resetCasinoGameStart,
  resetCasinoGameSuccess,
  updateCasinoStatusStart,
  updateCasinoStatusComplete,
  getSuperAdminAggregatorsStart,
  getSuperAdminAggregatorsSuccess,
  getSuperAdminAggregatorsFailure,
  createSuperAdminAggregatorStart,
  createSuperAdminAggregatorComplete,
  updateSuperAdminAggregatorStatusStart,
  updateSuperAdminAggregatorStatusComplete,
  getSuperAdminGameCategoryStart,
  getSuperAdminGameCategorySuccess,
  getSuperAdminGameCategoryFailure,
  getSuperAdminGameSubCategoryStart,
  getSuperAdminGameSubCategorySuccess,
  getSuperAdminGameSubCategoryFailure,
  updateSACasinoGamesStatusStart,
  updateSACasinoGamesStatusComplete,
  getAllSAProvidersStart,
  getAllSAProvidersSuccess,
  getAllSAProvidersFailure,
  getFreeSpinGamesStart,
  getFreeSpinGamesSuccess,
  getFreeSpinGamesFailure,
  updateReorderGamesStart,
  updateReorderGamesSuccess,
  updateReorderGamesFailure,
  deleteCasinoSubCategoriesStart,
  deleteCasinoSubCategoriesSuccess,
  updateCasinoStart,
  updateCasinoComplete,
  createCasinoStart,
  createCasinoComplete,
  addGamesToSubCategoryStart,
  addGamesToSubCategoryComplete,
  updateCategoryReOrderStart,
  updateCategoryReOrderComplete,
  getSuperAdminPopularGameStart,
  getSuperAdminPopularGameSuccess,
  getSuperAdminPopularGameFailure,
  handleSuperAdminPopularGameStart,
  updateStatusStart,
  updateStatusSuccess,
  updateStatusFailure,
  getSuperAdminNewGameStart,
  getSuperAdminNewGameSuccess,
  getSuperAdminNewGameFailure,
  updateGameThumbnailURLComplete,
  updateGameThumbnailURLFailure,
  updateGameThumbnailURLStart,
  deleteCategoryFailure,
  deleteCategorySuccess,
  deleteCategoryStart,
  addCasinogameCategoryStart,
  addCasinogameCategorySuccess,
  addCasinogameCategoryFailure,

  getCasinoGamesCategoryStart,
  getCasinoGamesCategorySuccess,
  getCasinoGamesCategoryFailure,

  getCasinoGamesCategoryCountStart,
  getCasinoGamesCategoryCountSuccess,
  getCasinoGamesCategoryCountFailure,

  deleteCasinoGamesCategoryStart,
    deleteCasinoGamesCategorySuccess,
    deleteCasinoGamesCategoryFailure,



} from '../redux-slices/superAdminCasinoManagement'
import { toast } from '../../components/Toast'

import { objectToFormData } from '../../utils/objectToFormdata'
import { getAllGamesStart } from '../redux-slices/tenantCasino'
import { ca } from 'date-fns/locale'

export default function* superAdminCasinoManagementWatcher() {
  yield takeLatest(getAllCasinoProvidersStart.type, getAllCasinoProvidersWorker)
  yield takeLatest(getAllCasinoGamesStart.type, getAllCasinoGamesWorker)
  yield takeLatest(createCasinoGameStart.type, createCasinoGameWorker)
  yield takeLatest(createCasinoProviderStart.type, createCasinoProviderWorker)
  yield takeLatest(updateCasinoGameStart.type, updateCasinoGameWorker)
  yield takeLatest(updateCasinoProviderStart.type, updateCasinoProviderWorker)
  yield takeLatest(updateCasinoStart.type, updateCasinoWorker)
  yield takeLatest(createCasinoStart.type, createCasinoWorker)
  yield takeLatest(resetCasinoGameStart.type, resetCasinoGameWorker)
  yield takeLatest(updateCasinoStatusStart.type, updateCasinoStatusWorker)
  yield takeLatest(getSuperAdminAggregatorsStart.type, getSuperAdminAggregatorsWorker)
  yield takeLatest(createSuperAdminAggregatorStart.type, createSuperAdminAggregatorWorker)
  yield takeLatest(updateSuperAdminAggregatorStatusStart.type, updateSuperAdminAggregatorStatusWorker)
  yield takeLatest(getSuperAdminGameCategoryStart.type, getSuperAdminGameCategoryWorker)
  yield takeLatest(getSuperAdminGameSubCategoryStart.type, getSuperAdminGameSubCategoryWorker)
  yield takeLatest(updateSACasinoGamesStatusStart.type, updateSACasinoGamesStatusWorker)
  yield takeLatest(getAllSAProvidersStart.type, getAllSAProvidersWorker)
  yield takeLatest(getFreeSpinGamesStart.type, getFreeSpinGamesWorker)
  yield takeLatest(updateReorderGamesStart.type, updateReorderGamesWorker)
  yield takeLatest(deleteCasinoSubCategoriesStart.type, deleteCasinoWorker)
  yield takeLatest(addGamesToSubCategoryStart.type, addGamesToSubCategoryWorker)
  yield takeLatest(
    updateCategoryReOrderStart.type, updateSubCategoryOrder
  )
  yield takeLatest(getSuperAdminNewGameStart.type, getSuperAdminNewGameWorker)
  yield takeLatest(getSuperAdminPopularGameStart.type, getSuperAdminPopularGameWorker)
  yield takeLatest(handleSuperAdminPopularGameStart.type, handleSuperAdminPopularGameWorker)
  yield takeLatest(updateStatusStart.type, updateStatusCasinoWorker)
  yield takeLatest(updateGameThumbnailURLStart.type, updateCasinoGameThumbnailURLWorker)
  yield takeLatest(deleteCategoryStart.type, deleteCasinoCategoryWorker)
  yield takeLatest(addCasinogameCategoryStart.type, addCasinoGameCategoryWorker)
  yield takeLatest(getCasinoGamesCategoryStart.type, getCasinoGamesCategoryWorker)

  yield takeLatest(getCasinoGamesCategoryCountStart.type, getCasinoGamesCategoryCountStartWorker)

  yield takeLatest(deleteCasinoGamesCategoryStart.type, deleteCasinoGamesCategorytartWorker)




}

function* getAllCasinoProvidersWorker(action) {
  try {
    const { limit, pageNo, search = '' } = action && action.payload
    const { data } = yield getAllCasinoProviders({
      limit,
      pageNo,
      search
    })

    yield put(getAllCasinoProvidersSuccess(data?.data?.providerList))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0].description, 'error')

    yield put(getAllCasinoProvidersFailure(e?.response?.data?.errors[0].description))
  }
}

function* resetCasinoGameWorker() {
  yield put(resetCasinoGameSuccess())
}

function* addGamesToSubCategoryWorker(action) {
  try {
    const { gameSubCategoryId, games, navigate } = action && action.payload

    yield addGamesToSubCategory({
      gameSubCategoryId: parseInt(gameSubCategoryId),
      games
    })

    yield toast('Games Added To Sub Category', 'success')

    // navigate(TenantRoutes.CasinoSubCategory)

    yield put((addGamesToSubCategoryComplete()))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put((addGamesToSubCategoryComplete()))
  }
}

function* updateSubCategoryOrder(action) {
  try {
    const { data, navigate, isSubCategory } = action && action.payload
    isSubCategory ? yield updateSubCategoryReOrder(data) : updateCategoryReOrder(data)
    yield put(updateCategoryReOrderComplete())
    yield toast(`Casino${isSubCategory ? ' Sub' : ''} Category Updated Successfully`, 'success')
    yield delay(1000)
    navigate(isSubCategory ? '/admin/casino-sub-category' : '/admin/casino-category')
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')
  }
}

function* getAllCasinoGamesWorker(action) {
  try {

    const { bonusId, limit, pageNo, casinoCategoryId, search, isActive, tenantId, selectedProvider, freespins, addGame, gameSubCategoryId, reorder, bonusFilter } = action && action.payload

    const { data } = yield getAllCasinoGames({
      limit,
      pageNo,
      casinoCategoryId,
      search,
      isActive,
      tenantId,
      selectedProvider,
      freespins: freespins || '',
      bonusId: bonusId || '',
      addGame: addGame || false,
      gameSubCategoryId: gameSubCategoryId || "",
      reorder: reorder || "false",
      bonusFilter: bonusFilter || ''
    })

    yield put(getAllCasinoGamesSuccess(data?.data?.categoryGames))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getAllCasinoGamesFailure(e?.response?.data?.errors[0]?.description))
  }
}
function* createCasinoProviderWorker(action) {
  try {
    const { data, limit, pageNo, search } = action && action.payload

    yield createCasinoProvider(objectToFormData(data))
    yield put(getAllCasinoProvidersStart({ limit, pageNo, search }))

    yield toast('Provider created', 'success')
    yield put(createCasinoProviderComplete())
  } catch (e) {
    yield put(createCasinoProviderComplete())

    yield toast(e?.response?.data?.errors[0].description, 'error')
  }
}

function* createCasinoWorker(action) {
  try {
    const { data, limit, pageNo, search, code } = action && action.payload

    switch (code) {
      case 'CASINO_CATEGORY':
        yield createCasinoCategory((data))
        yield put(getSuperAdminGameCategoryStart({
          limit, pageNo, search, isActive: '', gameCategoryId: '', tenantId: ''
        }))
        yield toast('Category created', 'success')
        break;
      case 'CASINO_PROVIDER':
        yield createCasinoProvider(objectToFormData(data))
        yield put(getAllCasinoProvidersStart({
          limit, pageNo, search, isActive: '', gameCategoryId: '', tenantId: ''
        }))
        yield toast('Provider created', 'success')
        // code block
        break;
      case 'CASINO_SUB_CATEGORY':
        yield createCasinoSubCategory(objectToFormData(data))
        yield put(getSuperAdminGameSubCategoryStart({
          limit, pageNo, search, isActive: '', gameCategoryId: '', tenantId: ''
        }))
        yield toast('casino Sub-Category created', 'success')

        break;
      case 'CASINO_GAME':
        yield createCasinoGame(objectToFormData(data))
        yield put(getAllCasinoGamesStart({
          limit, pageNo, search, isActive: '', gameCategoryId: '', tenantId: ''
        }))
        yield toast('casino games created', 'success')
        break;


      default: {
        return null
      }
    }

    yield put(createCasinoComplete())
  } catch (e) {
    yield put(createCasinoComplete())

    yield toast(e?.response?.data?.errors[0].description, 'error')
  }
}


function* createCasinoGameWorker(action) {
  try {
    const { data, casinoProviderId, limit, pageNo } = action && action.payload
    yield createCasinoGame(objectToFormData(data))

    yield toast('Game created', 'success')
    if (casinoProviderId) {
      yield put(getAllCasinoGamesStart({
        casinoProviderId,
        limit,
        pageNo
      }))
    }

    yield put(createCasinoGameComplete())
  } catch (e) {
    yield put(createCasinoGameComplete())

    yield toast(e?.response?.data?.errors[0].description, 'error')
  }
}

function* updateCasinoProviderWorker(action) {
  try {
    const { data, limit, pageNo, search } = action && action.payload

    yield updateCasinoProvider(objectToFormData(data))

    yield toast('Provider updated', 'success')
    yield put(getAllCasinoProvidersStart({ limit, pageNo, search }))

    yield put(updateCasinoProviderComplete())
  } catch (e) {
    yield put(updateCasinoProviderComplete())

    yield toast(e?.response?.data?.errors[0].description, 'error')
  }
}

function* updateCasinoWorker(action) {
  try {
    const { data, limit, pageNo, search, code, formData, isformdata } = action && action.payload
    switch (code) {
      case 'CASINO_CATEGORY':
        yield updateCasinoCategory(isformdata ? formData : data)
        yield put(getSuperAdminGameCategoryStart({
          limit, pageNo, search, isActive: '', gameCategoryId: '', tenantId: ''
        }))
        yield toast('Category updated', 'success')
        break;
      case 'CASINO_PROVIDER':
        yield updateCasinoProvider(objectToFormData(data))
        yield put(getAllCasinoProvidersStart({
          limit, pageNo, search, isActive: '', gameCategoryId: '', tenantId: ''
        }))
        yield toast('Provider updated', 'success')
        // code block
        break;
      case 'CASINO_SUB_CATEGORY':
        yield updateCasinoSubCategory(objectToFormData(data))
        yield put(getSuperAdminGameSubCategoryStart({
          limit, pageNo, search, isActive: '', gameCategoryId: '', tenantId: ''
        }))
        yield toast('casino Sub-Category updated', 'success')

        break;
      case 'CASINO_GAME':
        yield updateCasinoGame(objectToFormData(data))
        yield put(getAllCasinoGamesStart({
          limit,
          pageNo,
          casinoCategoryId: '',
          search,
          isActive: "",
          tenantId: "",
          selectedProvider: "",
          freespins: '',
          bonusId: ""
        }))
        yield toast('casino games updated', 'success')
        break;


      default: {

      }
    }

    yield put(updateCasinoComplete())
  } catch (e) {
    yield put(updateCasinoComplete())

    yield toast(e?.response?.data?.errors[0].description, 'error')
  }
}

function* updateCasinoGameWorker(action) {
  try {
    const { data, casinoProviderId, limit, pageNo } = action && action.payload

    yield updateCasinoGame(objectToFormData(data))

    yield put(updateCasinoGameComplete())

    yield put(getAllCasinoGamesStart({
      casinoProviderId,
      limit,
      pageNo
    }))

    yield toast('Game updated', 'success')
  } catch (e) {
    yield put(updateCasinoGameComplete())

    yield toast(e?.response?.data?.errors[0].description, 'error')
  }
}

function* updateCasinoStatusWorker(action) {
  try {
    const { data, limit, pageNo, search } = action && action.payload
    yield superAdminViewToggleStatus(data)
    yield toast('Status updated', 'success')

    yield put(getAllCasinoProvidersStart({ limit, pageNo, search }))

    yield put(updateCasinoStatusComplete())
  } catch (e) {
    yield put(updateCasinoStatusComplete())

    yield toast(e?.response?.data?.errors[0].description, 'error')
  }
}


function* deleteCasinoWorker(action) {
  try {
    const {
      data,
      limit,
      pageNo,
      casinoCategoryId,
      search,
      isActive,
      tenantId,
      selectedProvider,
      gameSubCategoryId,
      casinoGameId,

    } = action && action.payload


    switch (data.code) {
      case 'CASINO_CATEGORY':
        yield deleteTenantAdminCategory()
        yield put(getSuperAdminGameCategoryStart({
          data,
          limit,
          pageNo,
          casinoCategoryId,
          search,
          isActive,
          tenantId,
          selectedProvider
        }))
        break;
      case 'CASINO_PROVIDER':
        yield deleteTenantAdminCasinoProvider()
        yield put(getAllCasinoProvidersStart({
          data,
          limit,
          pageNo,
          casinoCategoryId,
          search,
          isActive,
          tenantId,
          selectedProvider
        }))
        // code block
        break;
      case 'CASINO_SUB_CATEGORY':
        yield deleteTenantAdminSubCategory({ gameSubCategoryId: gameSubCategoryId })
        yield put(getSuperAdminGameSubCategoryStart({
          data,
          limit,
          pageNo,
          casinoCategoryId: "",
          search,
          isActive: "",
          tenantId: "",
          selectedProvider: "",
          gameCategoryId: ""
        }))
        break;
      case 'CASINO_GAME':
        yield deleteTenantAdminCasinoGames({ casinoGameId: casinoGameId })
        yield put(getAllCasinoGamesStart({
          data,
          limit,
          pageNo,
          casinoCategoryId: "",
          search,
          isActive: "",
          tenantId: "",
          selectedProvider: "",
          gameCategoryId: ""
        }))
        break;


      default: {

      }
        // code block
        yield toast('Status updated', 'success')

    }




    yield put(updateSACasinoGamesStatusComplete())
  } catch (e) {
    yield put(updateSACasinoGamesStatusComplete())

    yield toast(e?.response?.data?.errors[0].description, 'error')
  }
}

function* updateSACasinoGamesStatusWorker(action) {
  try {
    const {
      data,
      limit,
      pageNo,
      casinoCategoryId,
      search,
      isActive,
      tenantId,
      selectedProvider
    } = action && action.payload

    yield superAdminViewToggleStatus(data)
    yield toast('Status updated', 'success')

    switch (data.code) {
      case 'CASINO_CATEGORY':
        yield put(getSuperAdminGameCategoryStart({
          data,
          limit,
          pageNo,
          casinoCategoryId,
          search,
          isActive,
          tenantId,
          selectedProvider
        }))
        break;
      case 'CASINO_PROVIDER':
        // code block
        break;
      case 'CASINO_SUB_CATEGORY':
        yield put(getSuperAdminGameCategoryStart({
          data,
          limit,
          pageNo,
          casinoCategoryId,
          search,
          isActive,
          tenantId,
          selectedProvider
        }))
        break;
      case 'CASINO_GAME':
        yield put(getAllCasinoGamesStart({
          data,
          limit,
          pageNo,
          casinoCategoryId,
          search,
          isActive,
          tenantId,
          selectedProvider
        }))
        break;


      default:
      // code block
    }
    yield put(deleteCasinoSubCategoriesSuccess())
  } catch (e) {
    yield put(deleteCasinoSubCategoriesSuccess())

    yield toast(e?.response?.data?.errors[0].description, 'error')
  }
}

function* getSuperAdminAggregatorsWorker(action) {
  try {
    const { limit, pageNo } = action && action.payload
    const { data } = yield getSuperAdminAggregators({
      limit,
      pageNo
    })

    yield put(getSuperAdminAggregatorsSuccess(data?.data?.aggregators))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0].description, 'error')

    yield put(getSuperAdminAggregatorsFailure(e?.response?.data?.errors[0].description))
  }
}

function* createSuperAdminAggregatorWorker(action) {
  try {
    const { data, limit, pageNo } = action && action.payload
    yield createSuperAdminAggregator(data)

    yield toast('Aggregator Created', 'success')

    yield put(createSuperAdminAggregatorComplete())
    yield put(getSuperAdminAggregatorsStart({ limit, pageNo }))
  } catch (e) {
    yield put(createSuperAdminAggregatorComplete())

    yield toast(e?.response?.data?.errors[0].description, 'error')
  }
}

function* updateSuperAdminAggregatorStatusWorker(action) {
  try {
    const { data, limit, pageNo } = action && action.payload

    yield superAdminViewToggleStatus(data)

    yield toast('Status Updated', 'success')

    yield put(updateSuperAdminAggregatorStatusComplete())
    yield put(getSuperAdminAggregatorsStart({ limit, pageNo }))
  } catch (e) {
    yield put(updateSuperAdminAggregatorStatusComplete())

    yield toast(e?.response?.data?.errors[0].description, 'error')
  }
}

function* getSuperAdminGameCategoryWorker(action) {
  console.log('action', action);
  try {

    const { limit, pageNo, search, tenantId, isActive, categoryType , status} = action && action.payload
    const { data } = yield getSuperAdminGameCategory({
      limit,
      pageNo,
      search,
      tenantId,
      isActive,
      categoryType,
      status
    })
    yield put(getSuperAdminGameCategorySuccess(data?.data?.result))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0].description, 'error')

    yield put(getSuperAdminGameCategoryFailure(e?.response?.data?.errors[0].description))
  }
}

function* getSuperAdminNewGameWorker(action) {
  try {
    const { limit, pageNo, search } = action.payload
    console.log('limit,page', limit, pageNo);
    const { data } = yield getSuperAdminNewGame({ limit, pageNo, search });
    yield put(getSuperAdminNewGameSuccess(data?.data?.newGameList))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0].description, 'error')

    yield put(getSuperAdminNewGameFailure(e?.response?.data?.errors[0].description))
  }
}

function* getSuperAdminPopularGameWorker(action) {
  try {
    const { limit, pageNo, search } = action.payload
    console.log('limit,page', limit, pageNo);
    const { data } = yield getSuperAdminPopularGame({ limit, pageNo, search });
    yield put(getSuperAdminPopularGameSuccess(data?.data?.popularGameList))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0].description, 'error')

    yield put(getSuperAdminPopularGameFailure(e?.response?.data?.errors[0].description))
  }
}

function* handleSuperAdminPopularGameWorker(action) {
  try {
    const { limit, pageNo, from, casinoCategoryId, search, isActive, tenantId, selectedProvider } = action && action.payload
    const { data } = yield handlePopularGame(action.payload?.data);
    if (data?.data?.success) toast(data?.data?.message, 'success');
    if (from === 'casino_page') {
      yield put(getAllCasinoGamesStart({
        limit,
        pageNo,
        casinoCategoryId,
        search,
        isActive,
        tenantId,
        selectedProvider
      }))
    } else if (from === 'popular_page') {
      yield put(getSuperAdminPopularGameStart({ limit, pageNo, search }))
    } else if (from === 'new_page') {
      yield put(getSuperAdminNewGameStart({ limit, pageNo, search }))
    }

  } catch (e) {
    console.log('error', e);
    yield toast(e?.response?.data?.errors[0].description, 'error')

  }
}

function* getSuperAdminGameSubCategoryWorker(action) {
  try {
    const { limit, pageNo, search, gameCategoryId, isActive, tenantId } = action && action.payload
    const { data } = yield getSuperAdminGameSubCategory({
      limit,
      pageNo,
      search,
      gameCategoryId,
      isActive,
      tenantId
    })

    yield put(getSuperAdminGameSubCategorySuccess(data?.data?.casinoSubCategory))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0].description, 'error')

    yield put(getSuperAdminGameSubCategoryFailure(e?.response?.data?.errors[0].description))
  }
}

function* getAllSAProvidersWorker() {
  try {
    const { data } = yield getAllSAProviders()

    yield put(getAllSAProvidersSuccess(data?.data?.providerList))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getAllSAProvidersFailure())
  }
}

function* getFreeSpinGamesWorker(action) {
  try {
    const { limit, pageNo, providerId, search, bonusId } = action && action.payload

    const { data } = yield getFreeSpinGames({
      limit, pageNo, providerId, search, bonusId, isTenant: false
    })

    yield put(getFreeSpinGamesSuccess(data?.data?.gameWithFreespin))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getFreeSpinGamesFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* updateReorderGamesWorker(action) {
  try {
    const { data, casinoCategoryId } = action && action.payload
    const res = yield updateReorderGames({ data })

    yield put(updateReorderGamesSuccess())
    yield put(
      getAllGamesStart({
        limit: '',
        pageNo: '',
        casinoCategoryId,
        isActive: '',
        orderBy: '',
        sort: '',
        providerId: ''
      })
    )
    yield toast(res.data.message, 'success')
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(updateReorderGamesFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* updateStatusCasinoWorker(action) {
  try {
    const {
      search, limit, pageNo, data
    } = action.payload
    const res = yield updateStatus(data)
    yield toast(res.data.message, 'success')
    yield put(updateStatusSuccess())
    yield put(yield put(getAllCasinoGamesStart({
      limit,
      pageNo,
      casinoCategoryId: '',
      search,
      isActive: "",
      tenantId: "",
      selectedProvider: "",
      freespins: '',
      bonusId: ""
    })))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(updateStatusFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* updateCasinoGameThumbnailURLWorker(action) {
  try {
    const {
      data, onSuccess
    } = action.payload

    const response = yield call(updateCasinoGameThumbnailURL, data)

    // Check if the response indicates success
    if (response && response.status >= 200 && response.status < 300) {
      yield toast('Game URL has been updated', 'success')
      yield put(updateGameThumbnailURLComplete())

      if (onSuccess && typeof onSuccess === 'function') {
        yield call(onSuccess)
      }
    } else {
      throw new Error(response?.data?.message || 'Update failed')
    }
  } catch (e) {
    console.error('Update thumbnail URL error:', e)

    const errorMessage = e?.response?.data?.errors?.[0]?.description ||
      e?.response?.data?.message ||
      e?.message ||
      'Failed to update game URL'

    yield toast(errorMessage, 'error')
    yield put(updateGameThumbnailURLFailure(errorMessage))
  }
}


// function* getFreeSpinGamesWorker(action) {
function* deleteCasinoCategoryWorker(action) {

  try {
    const { gameCategoryId } = action && action.payload

    const response = yield deleteCasinoCategory({
      gameCategoryId: gameCategoryId
    })
    yield toast(response?.data?.data?.message, 'success')
    yield put(deleteCategorySuccess(response?.data?.data))
  } catch (e) {

    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(deleteCategoryFailure(e?.response?.data?.errors[0]?.description))
  }
}



function* addCasinoGameCategoryWorker(action) {
  try {
    const {
      data, onSuccess
    } = action.payload

    const response = yield call(addCasinoGameCategory, data)
    // Check if the response indicates success
    if (response && response.status >= 200 && response.status < 300) {
      yield toast(response?.data?.data?.message || 'Updated successfully', 'success')
      yield put(addCasinogameCategorySuccess())

      if (onSuccess && typeof onSuccess === 'function') {
        // yield toast(errorMessage, 'error')
        yield call(onSuccess)

      }
    } else {
      throw new Error(response?.data?.message || 'Update failed')
    }
  } catch (e) {

    const errorMessage = e?.response?.data?.errors?.[0]?.description ||
      e?.response?.data?.message ||
      e?.message ||
      'Failed to update game URL'

    yield toast(errorMessage, 'error')
    yield put(addCasinogameCategoryFailure(errorMessage))
  }
}

// getCasinoGamesCategoryWorker

function* getCasinoGamesCategoryWorker(action) {
  try {
    const {
      data, onSuccess
    } = action.payload

    const response = yield call(getCategoryGames, data)
    // Check if the response indicates success
    if (response && response.status >= 200 && response.status < 300) {
      console.log("getCasinoGamesCategoryWorker", response, response?.data?.data?.result);
      yield put(getCasinoGamesCategorySuccess(response?.data?.data?.result))

      if (onSuccess && typeof onSuccess === 'function') {
        yield call(onSuccess)

      }
    } else {
      throw new Error(response?.data?.message || 'Update failed')
    }
  } catch (e) {

    const errorMessage = e?.response?.data?.errors?.[0]?.description ||
      e?.response?.data?.message ||
      e?.message ||
      'Failed to update game URL'

    yield toast(errorMessage, 'error')
    yield put(getCasinoGamesCategoryFailure(errorMessage))
  }
}

function* getCasinoGamesCategoryCountStartWorker(action) {
  try {
    const {
      data, onSuccess, onError
    } = action.payload
    const response = yield call(getCategoryGamesCount, data)
    // Check if the response indicates success
    if (response && response.status >= 200 && response.status < 300) {
      yield put(getCasinoGamesCategoryCountSuccess(response?.data?.data?.data))


      const featuredCount = Number(response?.data?.data?.data?.featuredGameCount || 0);
      const gameLimit = Number(response?.data?.data?.data?.gameLimit || 0);

      const canAdd = featuredCount < gameLimit;

      if (onSuccess && typeof onSuccess === 'function' && canAdd) {

        yield call(onSuccess)

      }
      else {
        yield call(onError, response?.data?.data?.data)
      }
    } else {

      throw new Error(response?.data?.message || 'Update failed')
    }
  } catch (e) {

    const errorMessage = e?.response?.data?.errors?.[0]?.description ||
      e?.response?.data?.message ||
      e?.message ||
      'Failed to update game URL'

    yield toast(errorMessage, 'error')
    yield put(getCasinoGamesCategoryCountFailure(errorMessage))
  }
}



function* deleteCasinoGamesCategorytartWorker(action) {
  try {
    const {
      data, onSuccess, onError
    } = action.payload
    const response = yield call(deleteCagegoryGame, data)

    console.log({response,  data, onSuccess, onError} , "responseeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee")



    // Check if the response indicates success
    if (response && response.status >= 200 && response.status < 300) {

      yield put(deleteCasinoGamesCategorySuccess(response?.data?.data?.data))

     
      if (onSuccess && typeof onSuccess === 'function') {

        yield call(onSuccess , {
          successMsg : response?.data?.data?.message || "Record deleted successfull",
          data : response?.data?.data?.data
        })

      }
     
    } else {

      throw new Error(response?.data?.message || 'Update failed')
    }
  } catch (e) {

    const errorMessage = e?.response?.data?.errors?.[0]?.description ||
      e?.response?.data?.message ||
      e?.message ||
      'Failed to update game URL'

    yield toast(errorMessage, 'error')
    yield put(deleteCasinoGamesCategoryFailure(errorMessage))
  }
}

